/**
 * Meeting Api
 */
// 미팅 카운트 및 리스트
export async function getMtListCnt(app, wsId, listType) {
  // console.log('getMtMyList')
  return await app.$axios.post('/v1/mt/count', { wsId, listType })
}
// 내 미팅 리스트
export async function getMtMyList(app, wsId) {
  // console.log('getMtMyList')
  return await app.$axios.post('/v1/mt/list/my', { wsId })
}

// 팀 미팅 리스트
export async function getMtTeamList(app, wsId) {
  // console.log('getMtTeamList')
  return await app.$axios.post('/v1/mt/list/team', { wsId })
}

// 미팅 정보 조회
export async function getMtInfo(app, wsId, mtId, userId, isDetail) {
  // console.log('getMtInfo')
  return await app.$axios.post('/v1/mt/info', { wsId, mtId, userId, isDetail })
}

// 미팅의 클립 조회 (배열)
export async function getClipList(app, mtId) {
  return await app.$axios.post('/v1/mt/clip', {
    mtId,
  })
}

// 미팅 정보 수정
export async function setMtUpdate(app, wsId, mtId, mtTopic, mtHashTag, isEnded) {
  // console.log('setMtUpdate')
  return await app.$axios.post('/v1/mt/update', {
    wsId,
    mtId,
    mtTopic,
    mtHashTag,
    isEnded,
  })
}

// 미팅 생성
export async function setMtPermission(app, wsId, mtId, userId, mtPermission) {
  // console.log('setMtPermission')
  return await app.$axios.post('/v1/mt/permission', {
    wsId,
    mtId,
    userId,
    mtPermission,
  })
}

export async function setPublicMt(app, wsId, mtId, userId, isPublic) {
  // console.log('setMtPermission')
  return await app.$axios.post('/v1/mt/setpublic', {
    wsId,
    mtId,
    userId,
    isPublic,
  })
}

// 미팅 생성
export async function setCreateMt(
  app,
  wsId,
  mtTopic,
  mtHashTag,
  mtType,
  chType,
  chId = null,
  chCategory,
  templateInfo = null
) {
  // 채널 관련 추가
  let mtPermission

  if (chType === 'P') mtPermission = 'private'
  else if (chType === 'W') mtPermission = 'workspace'

  chId = chId.includes('CH:') ? chId : `CH:${chId}`

  let params = {
    wsId,
    mtTopic,
    mtHashTag,
    mtPermission,
    chCategory,
    mtType,
    chId,
  }

  if (chId !== null) params['chId'] = chId
  if (templateInfo) params['templateInfo'] = templateInfo

  return await app.$axios.post('/v1/mt/create', params)
}

// 미팅 수정
export async function setUpdateMt(app, wsId, mtId, mtTopic, mtVisibleTo, mtHashTag) {
  // console.log('setUpdateMt')
  return await app.$axios.post('/v1/mt/update', {
    wsId,
    mtId,
    mtTopic,
    mtVisibleTo,
    mtHashTag,
  })
}

// 미팅 삭제
export async function deleteMeeting(app, type, wsId, mtId) {
  // console.log('deleteMeeting')
  return await app.$axios.post('/v1/mt/delete', { type, wsId, mtId })
}

// 미팅 참여자/권한 조회
export async function getMtPermission(app, mtId) {
  // console.log('getMtPermission')
  return await app.$axios.post('/v1/mt/attendee', { mtId })
}

// Public 미팅 확인
export async function chkMtPublic(app, mtId) {
  // console.log('chkMtPublic')
  return await app.$axios.post('/v1/mt/public/check', { mtId })
}

// Public 미팅 정보
export async function getPublicMtInfo(app, mtId) {
  // console.log('getPublicMtInfo')
  return await app.$axios.post('/v1/mt/public/info', { mtId })
}

// Public 미팅 클립 리스트
export async function getPublicMtClip(app, mtId, userId) {
  // console.log('getPublicMtClip')
  return await app.$axios.post('/v1/mt/public/clip', { mtId, userId })
}

// 지정자 선택 리스트
export async function getTargetList(app, mtId, userId, isEmail) {
  // console.log('getTargetList')
  return await app.$axios.post('/v1/mt/target-list', { mtId, userId, isEmail })
}

// Public Inbox 호출
export async function getPublicInboxList(app, wsDomain, chId, userId, page) {
  // console.log('getPublicInboxList')
  return await app.$axios.post('/v1/inbox/public-inbox', { wsDomain, chId, userId, page })
}
